export default "__VITE_ASSET__fwnE3vRC__"